import { createRequestWithComputedFilters } from '@/utils/api'
import store from '@/store'
import network from '@/utils/network'

/**
 * Récupère les abonnements des factures de l'agence
 * @type {function(?{filters?: *, ...opt}): *}
 */
export const fetchAgencyInvoicesRecurrence = createRequestWithComputedFilters(
  async (params) => {
    const slugAgency = store.getters['user/agencySlug']
    const r = await network.post(`agency/${slugAgency}/fetch/invoiceRecurrence`, params)
    return r.data
  },
  {
    filters: {
      customer: 'all'
    }
  })

/**
 * Permet de créer un abonnement
 * @returns {Promise}
 * @param invoiceRecurrence
 */
export const postAgencyInvoicesRecurrence = async (invoiceRecurrence) => {
  const slugAgency = store.getters['user/agencySlug']
  const r = await network.post(`agency/${slugAgency}/invoiceRecurrence`, invoiceRecurrence)
  return r.data
}
